/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fine_These_Goose_ConquerInputs */

const fr_fine_these_goose_conquer = /** @type {(inputs: Fine_These_Goose_ConquerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réserver`)
};

/**

* @param {Fine_These_Goose_ConquerInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fine_these_goose_conquer = /** @type {((inputs?: Fine_These_Goose_ConquerInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fine_These_Goose_ConquerInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fine_these_goose_conquer(inputs)
});